// import React, { useState } from "react";
// import ReactQuill, { Quill } from "react-quill";
// import "react-quill/dist/quill.snow.css";
// import PropTypes from "prop-types";


// // ✅ Custom Quill Link Format to Always Open in a New Tab
// const Link = Quill.import("formats/link");
// class CustomLink extends Link {
//     static create(value) {
//         let node = super.create(value);
//         node.setAttribute("href", value);
//         node.setAttribute("target", "_blank"); // Open in new tab
//         node.setAttribute("rel", "noopener noreferrer"); // Security best practice
//         return node;
//     }
// }
// Quill.register(CustomLink, true); // Register custom link format

// const fontSizeOptions = ["10px", "12px", "14px", "16px", "18px", "20px", "24px", "30px", "36px", "48px"];

// const Size = Quill.import("attributors/style/size");
// Size.whitelist = fontSizeOptions;
// Quill.register(Size, true);

// const CKEditorComponent = ({ ...props }) => {
//     const handleChange = (html) => {
//         props.handleModelChange(props.modelName, html)
//     };


//     return (
//         <div>
//             <ReactQuill
//                 value={props.model}
//                 onChange={handleChange}
//                 modules={CKEditorComponent.modules}
//                 formats={CKEditorComponent.formats}
//                 bounds={".app"}
//                 placeholder={props.placeholder}
//             />
//         </div>
//     );
// };

// // ✅ Quill Modules Configuration (Now with Proper Font Size in px)
// CKEditorComponent.modules = {
//     toolbar: [
//         [{ header: [1, 2, 3, 4, 5, 6] }, { font: [] }, { size: fontSizeOptions }], // Headers & Font Styles // Font Sizes in px
//         [{ color: [] }, { background: [] }, "bold", "italic", "underline", "strike"], // Text & Background Color // Formatting
//         [{ list: "ordered" }, { list: "bullet" }, { indent: "-1" }, { indent: "+1" }, { align: [] }], // Lists & Indents // Alignment (Left, Center, Right, Justify)
//         ["link", "image"], // Media
//         ["clean"], // Remove Formatting
//     ],
//     clipboard: {
//         matchVisual: false,
//     },
// };

// // ✅ Quill Formats (Now Includes Font Size)
// CKEditorComponent.formats = [
//     "header",
//     "font",
//     "size", // ✅ Ensures Font Sizes in px Work
//     "color",
//     "background",
//     "bold",
//     "italic",
//     "underline",
//     "strike",
//     "list",
//     "bullet",
//     "indent",
//     "align",
//     "link",
//     "image",
// ];

// // PropType Validation
// CKEditorComponent.propTypes = {
//     placeholder: PropTypes.string,
// };

// export default CKEditorComponent;


// import React from 'react';
// import PropTypes from 'prop-types';
// import { CKEditor } from '@ckeditor/ckeditor5-react';
// import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
// import { API_ROOT } from '../../constants/constants';


// function CKEditorComponent(props) {
//     let imageUploadUrl = API_ROOT + 'UploadImages/Image';
//     let editorConfiguration = {
//         ckfinder: {
//             uploadUrl: imageUploadUrl,
//             options: {
//                 resourceType: 'Images'
//             }
//         },
//         image: {
//             toolbar: ['imageTextAlternative', 'toggleImageCaption', 'imageResize', '|', 'imageStyle:alignLeft', 'imageStyle:full', 'imageStyle:alignRight',],
//             styles: [
//                 'full',
//                 'alignLeft',
//                 'alignRight',
//             ]
//         },
//         link: {
//             // Automatically add target="_blank" and rel="noopener noreferrer" to all external links.
//             addTargetToExternalLinks: true,
//             decorators: {
//                 openInNewTab: {
//                     mode: 'manual',
//                     label: 'Open in a new tab',
//                     defaultValue: true, // Automatically check the "Open in a new tab" checkbox
//                     attributes: {
//                         target: '_blank',
//                         rel: 'noopener noreferrer'
//                     }
//                 }
//             }
//         },
//         toolbar: {
//             items: [
//                 'heading', '|',
//                 'fontfamily', 'fontsize', '|',
//                 'alignment', '|',
//                 'fontColor', 'fontBackgroundColor', '|',
//                 'bold', 'italic', 'strikethrough', 'underline', 'subscript', 'superscript', '|',
//                 'outdent', 'indent', '|',
//                 'bulletedList', 'numberedList', 'todoList', '|',
//                 'code', 'codeBlock', '|',
//                 'insertTable', '|',
//                 'uploadImage',
//                 'undo', 'redo',
//                 'link',
//             ],
//         },
//         heading: {
//             options: [
//                 { model: 'paragraph', title: 'Paragraph', view: 'p' },
//                 { model: 'heading1', view: 'h1', title: 'Heading 1' },
//                 { model: 'heading2', view: 'h2', title: 'Heading 2' },
//                 { model: 'heading3', view: 'h3', title: 'Heading 3' },
//                 { model: 'heading4', view: 'h4', title: 'Heading 4' }
//             ]
//         }


//     };

//     return (
//         <CKEditor
//             editor={ClassicEditor}
//             config={editorConfiguration}
//             data={props.model}
//             onInit={editor => {
//                 editor.setData(props.model);
//             }}
//             onChange={(event, editor) => {
//                 const data = editor.getData();
//                 props.handleModelChange(props.modelName, data)
//             }}
//         />
//     );
// }

// CKEditorComponent.propTypes = {
//     placeholderText: PropTypes.string.isRequired,
//     model: PropTypes.string.isRequired,
//     modelName: PropTypes.string.isRequired,
//     handleModelChange: PropTypes.func.isRequired
// };

// export default CKEditorComponent;


import React from 'react';
import PropTypes from 'prop-types';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { API_ROOT } from '../../constants/constants';

function CKEditorComponent(props) {
    const imageUploadUrl = `${API_ROOT}UploadImages/Image`;

    // 🧩 Helper: ensure each block (line) is properly separated
    const cleanEditorContent = (html) => {
        if (!html) return html;
        // Replace <br><br> inside headings or paragraphs with proper separate blocks
        return html
            .replace(/<br\s*\/?><br\s*\/?>/g, '</p><p>') // convert double <br> to new paragraph
            .replace(/<\/h([1-6])><p>/g, '</h$1><p>');   // ensure heading closes properly
    };

    const editorConfiguration = {
        ckfinder: {
            uploadUrl: imageUploadUrl,
            options: { resourceType: 'Images' }
        },
        image: {
            toolbar: [
                'imageTextAlternative',
                'toggleImageCaption',
                'imageResize', '|',
                'imageStyle:alignLeft',
                'imageStyle:full',
                'imageStyle:alignRight'
            ],
            styles: ['full', 'alignLeft', 'alignRight']
        },
        link: {
            addTargetToExternalLinks: true,
            decorators: {
                openInNewTab: {
                    mode: 'manual',
                    label: 'Open in a new tab',
                    defaultValue: true,
                    attributes: { target: '_blank', rel: 'noopener noreferrer' }
                }
            }
        },
        toolbar: {
            items: [
                'heading', '|',
                'fontfamily', 'fontsize', '|',
                'alignment', '|',
                'fontColor', 'fontBackgroundColor', '|',
                'bold', 'italic', 'strikethrough', 'underline', 'subscript', 'superscript', '|',
                'outdent', 'indent', '|',
                'bulletedList', 'numberedList', 'todoList', '|',
                'code', 'codeBlock', '|',
                'insertTable', '|',
                'uploadImage',
                'undo', 'redo',
                'link'
            ]
        },
        heading: {
            options: [
                { model: 'paragraph', view: 'p', title: 'Paragraph' },
                { model: 'heading1', view: 'h1', title: 'Heading 1' },
                { model: 'heading2', view: 'h2', title: 'Heading 2' },
                { model: 'heading3', view: 'h3', title: 'Heading 3' },
                { model: 'heading4', view: 'h4', title: 'Heading 4' },
                { model: 'heading5', view: 'h5', title: 'Heading 5' },
                { model: 'heading6', view: 'h6', title: 'Heading 6' },
            ]
        },

        
        // ✅ Prevent multiple lines in one heading
        enterMode: 'paragraph',     // Pressing Enter creates a new paragraph
        shiftEnterMode: 'br',       // Shift+Enter creates <br> (soft break)
        htmlSupport: {
            allow: [
                {
                    name: /.*/,      // allow all tags
                    attributes: true,
                    classes: true,
                    styles: true
                }
            ]
        }
    };

    return (
        <CKEditor
            editor={ClassicEditor}
            config={editorConfiguration}
            data={cleanEditorContent(props.model)} // 🧩 Clean input before loading
            onInit={(editor) => {
                editor.setData(cleanEditorContent(props.model));
            }}
            onChange={(event, editor) => {
                const data = editor.getData();
                props.handleModelChange(props.modelName, data);
            }}
        />
    );
}

CKEditorComponent.propTypes = {
    placeholderText: PropTypes.string.isRequired,
    model: PropTypes.string.isRequired,
    modelName: PropTypes.string.isRequired,
    handleModelChange: PropTypes.func.isRequired
};

export default CKEditorComponent;

